import React from "react";
import Media from "react-media";
import styles from "../Assets/css/clgCollab.module.css";
import back from "../Assets/img/Home/back.png";
import Group_7452 from "../Assets/img/Home/Group_7452.png";
import Image_5 from "../Assets/img/Home/Image_5.png";
import Diamond from "../Assets/img/Home/diamond.png";
import Image_7 from "../Assets/img/Home/Image_7.png";
import Image_9 from "../Assets/img/Home/Image_9.png";
import Colleges from "../Assets/img/Home/college_collab.png";
import CollegesMob from "../Assets/img/Home/college_collab_mob.png";
import Line_62 from "../Assets/img/Home/Line_62.png";
import Line_68 from "../Assets/img/Home/Line_68.png";
import Line_71 from "../Assets/img/Home/Line_71.png";
import Rectangle_441 from "../Assets/img/Home/Rectangle_441.png";
import TestHome from "../componentsofcourse/TestHome";
import { Link } from "react-router-dom";

const CollegeCollab2 = () => {
	return (
		<div>
			<br />
			<br />
			<br />
			<div class="container white-rect col-12 text-center">
				<Media query="(max-width: 650px)">
					{(matches) => {
						return matches ? (
							<img
								src={CollegesMob}
								class="imgResponsive"
								//   style={{ width: "85%" }}
							></img>
						) : (
							<img
								src={Colleges}
								class="imgResponsive"
								style={{ width: "85%" }}
							></img>
						);
					}}
				</Media>
			</div>
			<div class="container-fluid justify-content-center p-3 p-xl-4 p-md-3 p-sm-3 p-2 text-center">
				<h4 class="centered" style={{ fontFamily: "Poppins-Bold" }}>
					College
				</h4>
				<h4 class="centered" style={{ fontFamily: "Poppins-Bold" }}>
					Collaboration
				</h4>
				<br />
				<br />
				<br />
			</div>

			<div
				style={{ display: "block", flexDirection: "row" }}
				style={{ paddingLeft: "0px", paddingRight: "0px" }}
				class="container-fluid justify-content-center pt-3 pb-0 div_block mb-0"
			>
				{
					//<a style={{padding:'10px' , width:'320px' , fontSize:'20px'}} href="" className=" btn btn-warning text-white mx-auto d-block">Collaberate with us</a>
				}
				<div
					style={{ paddingLeft: "0px", paddingRight: "0px" }}
					class={`container-fluid justify-content-center pt-3 pb-0 ${styles.div_blockJ} mb-0`}
				>
					<div class={`row my-3 pt-3 pb-3 ${styles.sarveshJ}`}>
						<div class="col-xl-3 col-lg-3 col-md-3 col-sm-5 mx-2">
							<div class={`card ${styles.sarveshcardJ}`}>
								<img
									class={`card-img-top ${styles.sarveshimgJ}`}
									src={Image_5}
									alt="Card image cap"
								/>
								<div class="card-body">
									<h5
										class={`card-title ${styles.centeredJ} font-weight-bold`}
									>
										Sarvesh Mehtani
									</h5>
									<p
										class={`card-text ${styles.centeredJ}`}
										style={{ fontSize: "10px" }}
									>
										IIT BOMBAY - Computer Science
									</p>
								</div>
							</div>
							<br />
							<div class={styles.rectJ}>
								<p
									class={`${styles.centeredJ} ${styles.div_paraJ}`}
									style={{
										fontSize: "20px",
										fontFamily: "Poppins-Black",
										marginBottom: "0",
									}}
								>
									<b style={{ fontSize: "35px" }}>A.I.R 1</b>
									<br /> JEE ADVANCED 2017{" "}
								</p>
							</div>
						</div>
						<div
							class={`col-xl-4 col-lg-5 col-md-5 col-sm-5 ${styles.content_divJ} mb-2`}
						>
							<div
								class={`${styles.clgJ} px-3 py-2`}
								style={{ width: "100%", marginTop: "20%" }}
							>
								<p
									className={styles.div_paraJ}
									style={{ textAlign: "left" }}
								>
									Overall, I loved the fact that the whole
									process was tailored as per the individual’s
									interests & goals which made it very
									effective In pointing out our areas of
									strength and the areas that we need to work
									on.
								</p>
								<button
									type="button"
									class="btn btn-dark div_button-J"
									style={{ marginRight: "70%", width: "40%" }}
								>
									<Link
										style={{
											color: "white",
											fontFamily: "Poppins-Bold",
										}}
										to="/placementcourse"
									>
										Enroll Now
									</Link>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Media query="(max-width: 650px)">
				{(matches) => {
					return matches ? (
						<div></div>
					) : (
						<div>
							<img
								style={{
									float: "right",
									position: "absolute",
									width: "200px",
									right: "2px",
									marginTop: "-90px",
								}}
								className="diamond_img"
								src={Diamond}
							/>
						</div>
					);
				}}
			</Media>

			<div>
				<TestHome />
			</div>
		</div>
	);
};
export default CollegeCollab2;
